const _showLogPatches = false

export const logPatches = (component, type, patches, action) => {

  if (!patches.length || !_showLogPatches) return;

  console.groupCollapsed(`🔄 ${component}: State Change via: ${type}`);

  console.log('▶️ action', action);

  patches.forEach(p => {
    console.log(
      `▶️ ${p.op.toUpperCase()} at ${p.path.join(".")}:`,
      p.value
    );
  });
  console.groupEnd()

};